class ScxClickZoom extends HTMLElement {
  constructor() {
    super();
    this.imageZoom = document.getElementById(this.getAttribute("data-elem"));
    this.clickToUnZoom = this.getAttribute("data-click-to-unzoom") === "true";
  }

  connectedCallback() {
    this.updateZoom();
  }

  isZoomEnabled() {
    return this.imageZoom.style.getPropertyValue("--zoomEnabled") == "true";
  }

  setPointerZoom(e) {
    let pointer = {
      x: (e.offsetX * 100) / this.imageZoom.offsetWidth,
      y: (e.offsetY * 100) / this.imageZoom.offsetHeight,
    };
    this.imageZoom.style.setProperty("--zoom-x", pointer.x + "%");
    this.imageZoom.style.setProperty("--zoom-y", pointer.y + "%");
  }

  resetZoom() {
    this.imageZoom.style.setProperty("--zoomEnabled", "false");
    this.imageZoom.style.setProperty("--img-display", "none");
  }

  enableZoom() {
    this.imageZoom.style.setProperty("--img-display", "block");
    this.imageZoom.style.setProperty("--zoomEnabled", "true");
  }

  updateZoom = () => {
    this.imageZoom.addEventListener("click", (e) => {
      if (!this.isZoomEnabled()) {
        this.enableZoom();
        this.setPointerZoom(e);
        return;
      }

      if (this.clickToUnZoom && this.isZoomEnabled()) {
        this.resetZoom();
      }
    });

    this.imageZoom.addEventListener("mousemove", (e) => {
      if (this.imageZoom.style.getPropertyValue("--zoomEnabled") == "true") {
        this.setPointerZoom(e);
      }
    });

    this.imageZoom.addEventListener("mouseleave", () => {
      this.resetZoom();
    });
  };
}

customElements.define("scx-click-zoom", ScxClickZoom);
